export default __webpack_public_path__ + "static/media/groupBuyingShippingFeeChinese.9ec94bbf.png";